module.exports = "/assets/data/00266813facca93d31e0fdd2b34c2fe5-GU23.data.json";